export default "__VITE_ASSET__NSCj6mhO__"